export default __webpack_public_path__ + "static/media/manage_composed.6000e5de.png";